import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'gen-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoBoxComponent implements OnInit {
  @Input()
  message: string;

  @Input()
  iconType: 'check' | 'info' | 'error';

  @Input()
  iconCss: string;

  @Input()
  textTitle: string;

  @Input()
  textCss: string = '';

  @Input()
  set borderCss(css: string) {
    if (css) {
      this._borderCss = css;
    } else {
      this._borderCss = '';
    }
  };

  get borderCss() {
    return this._borderCss;
  }

  @Input()
  tooltipShow?: boolean = false;

  @Input()
  tooltipText: string;

  @Input()
  tooltipPosition: string;

  @Input()
  set backgroundCss(css: string) {
    if (css) {
      this._backgroundCss = css;
    } else {
      this._backgroundCss = '';
    }
  }

  get backgroundCss(): string {
    return this._backgroundCss;
  }

  private _backgroundCss: string = '';
  private _borderCss: string = '';


  constructor() { }

  ngOnInit() {
  }

}
